import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { Card } from "react-bootstrap";
import { getTenantDetails } from "../../api/TenantApi";
import moment from "moment";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { BsCalendarDate, BsCalendarCheck, BsHourglassSplit, BsBoxSeam, BsArrowRepeat } from "react-icons/bs";

const Subscription = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [tenantDetails, setTenantDetails] = useState({
    SubscriptionDate: null,
    ExpiryDate: null,
    RemainingDays: null,
  });

  useEffect(() => {
    getTenant();
  }, []);

  const getTenant = async () => {
    await getTenantDetails(user?.tenant_id).then((res) => {
      if (res.status === 200 && res?.data?.data?.subscriptions_date) {
        const subDate = new Date(res.data.data.subscriptions_date);
        const expDate = new Date(res.data.data.subscriptions_date);
        expDate.setFullYear(expDate.getFullYear() + 1);
        const RemainingDays = moment(expDate).diff(moment(), "days");
        setTenantDetails({ SubscriptionDate: subDate, ExpiryDate: expDate, RemainingDays });
      }
    });
  };

  const isActive = tenantDetails.RemainingDays !== null && tenantDetails.RemainingDays > 0;

  return (
    <Layout>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <span style={{ fontSize: "22px", fontWeight: 600 }}>Subscription</span>
        </div>
        <div className="d-flex justify-content-center">
        <Card className="shadow-sm" style={{ width: "380px", borderRadius: "16px", border: "1px solid #e0e0e0" }}>
          <Card.Body className="p-4">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4 pb-3" style={{ borderBottom: "1px solid #f0f0f0" }}>
              <span className="fw-bold text-dark" style={{ fontSize: "16px" }}>Subscription Status</span>
              <span className={`d-flex align-items-center gap-1 fw-semibold ${isActive ? "text-success" : "text-danger"}`} style={{ fontSize: "13px" }}>
                {isActive ? <FaCheckCircle size={14} /> : <FaTimesCircle size={14} />}
                {isActive ? "Active" : "Expired"}
              </span>
            </div>

            {/* Info Rows */}
            <div className="d-flex flex-column gap-3">

              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <BsBoxSeam size={15} /> Plan
                </span>
                <span className="fw-semibold" style={{ fontSize: "14px" }}>Basic</span>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <BsArrowRepeat size={15} /> Billing Term
                </span>
                <span className="fw-semibold" style={{ fontSize: "14px" }}>Annually</span>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <BsCalendarDate size={15} /> Start Date
                </span>
                <span className="fw-semibold" style={{ fontSize: "14px" }}>
                  {tenantDetails.SubscriptionDate ? moment(tenantDetails.SubscriptionDate).format("DD MMM YYYY") : "N/A"}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center">
                <span className="text-muted d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <BsCalendarCheck size={15} /> Expiry Date
                </span>
                <span className="fw-semibold" style={{ fontSize: "14px" }}>
                  {tenantDetails.ExpiryDate ? moment(tenantDetails.ExpiryDate).format("DD MMM YYYY") : "N/A"}
                </span>
              </div>

              <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderTop: "1px solid #f0f0f0" }}>
                <span className="text-muted d-flex align-items-center gap-2" style={{ fontSize: "13px" }}>
                  <BsHourglassSplit size={15} /> Remaining Days
                </span>
                <span
                  className="fw-bold"
                  style={{ fontSize: "15px", color: isActive ? (tenantDetails.RemainingDays < 30 ? "#e67e00" : "#198754") : "#dc3545" }}
                >
                  {tenantDetails.RemainingDays !== null ? `${tenantDetails.RemainingDays} Days` : "N/A"}
                </span>
              </div>

            </div>
          </Card.Body>
        </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Subscription;
